module.exports = __webpack_public_path__ + "img/dashboard.223309dc.svg";